import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowVideoVerification() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.video-verification')}
      description={t('feature-description.video-verification')}
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
